<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {PysicalInspectionPath} from "@/path";
import moment from "moment";
import orderData from "./orderData.vue";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    orderData
},
  data() {
    return {
      title: "Physical Inspection",
      items: [
        {
          text: "List",
        },
        {
          text: "Physical Inspection",
          active: true,
        },
      ],
      orders : [],
      selectedOrder : null,
      selectedType : null,
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      cdn : process.env.VUE_APP_AWS_CDN,
      filter : [],
      currentPage : 1,
      order_type : 'pending',
      search : '',
      fields : ["name","date_of_inspection",'gravies','packagings'],
    };
  },
  watch : {
    currentPage(){
      this.getOrders();
    },
    search(){
      this.getOrders();
    }
  },
  methods : {
    async getOrders(){
      try {
        let response = await axios.get(this.base_url + PysicalInspectionPath.GET_INSPECTION_DATA,{
          params : {
            page : this.currentPage,
            search : this.search
          }
        });
        if(response.data.status == true){
          this.orders = response.data.data;
        }
      }catch (e){
        console.log(e);
      }
    },
    reload(){
      this.getOrders();
    },
    setEdit(d){
      this.selectedOrder = d;
      this.$bvModal.show('bv-add-order');
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    openItems(v){
      this.selectedOrder = v;
      this.$bvModal.show('bv-view-order');
    },
    getFormatedDate(v){
      return moment(v).format('YYYY-MM-DD');
    },
    openData(type,v){
        this.selectedOrder = v;
        this.selectedType = type;
        this.$bvModal.show('show-items');
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getOrders();
    })
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row class="float-right">
              <b-col sm="12">
                <label>Search</label>
                <b-form-input class="w-100" v-model="search" :debounce="5000"></b-form-input>
              </b-col>
            </b-row>
            <div class="row mb-4">
                <b-modal id="show-items">
                    <orderData :type="selectedType" :res_id="selectedOrder?.res_id" :date_of_inspection="selectedOrder?.date_of_inspection"></orderData>
                </b-modal>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  :key="orders.key"
                  :items="orders.data"
                  :fields="fields"
                  responsive="sm"
                  :filter="filter"
                  :current-page="currentPage"
              >
                <template v-slot:cell(date_of_inspection)="row">
                    {{ getFormatedDate(row.item.date_of_inspection) }}
                </template>
                <template v-slot:cell(gravies)="row">
                    {{ row.item.gravies }}
                    <b-button @click="openData('gravies',row.item)" variant="secondary" size="sm"><i class="fa fa-list"></i></b-button>
                </template>
                <template v-slot:cell(packagings)="row">
                    {{ row.item.packagings }}
                    <b-button @click="openData('packagings',row.item)" variant="secondary" size="sm"><i class="fa fa-list"></i></b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="orders.key" v-model="currentPage" :total-rows="orders.total" :per-page="orders.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>